module.exports = __webpack_public_path__ + "media/images/information/information-794cf9998427b41c32eee08a999c6b7e.svg";